import MainContratistasContratos from '@/views/contratistas/contratos/Main.vue';
import DefaultContratistasContratos from '@/views/contratistas/contratos/Default.vue';
import MainAnticipos from '@/views/administracion/contratos/contrato/anticipos/Main.vue';
import MainContrato from '@/views/contratistas/contratos/contrato/Main.vue';
import MainConvenios from '@/views/administracion/contratos/contrato/convenios/Main.vue';
import MainCatalogo from '@/views/administracion/contratos/contrato/catalogo/Main.vue';
import MainPrograma from '@/views/administracion/contratos/contrato/programa/Main.vue';
import MainExpediente from '@/views/contratistas/contratos/contrato/expediente/Main.vue';
import MainContratoGenerales from '@/views/contratistas/contratos/contrato/Generales.vue';
import MainContratosFrentes from '@/views/contratistas/contratos/contrato/frentes/Main.vue';
import MainContratistasDiarioActividades from '@/views/contratistas/contratos/contrato/diario-actividades/Main.vue';
import MainContratistasMinutas from '@/views/contratistas/contratos/contrato/minutas/Main.vue';
import MainContratoReporteFisico from '@/views/administracion/ejecucion/contrato/reportes/Main.vue';
import MainContratosArchivosContratista from '@/views/contratistas/contratos/contrato/archivoscontratista/Main.vue';
import MainContratosDirectorio from '@/views/contratistas/contratos/contrato/directorio/Main.vue';
import MainContratosAgenda from '@/views/contratistas/contratos/contrato/agenda/Main.vue';

const auth = ['Supervisión:ver'];
const scopes = ['Supervisión:crear', 'Supervisión:editar'];

const contratos = [
  {
    path: 'contratos',
    component: MainContratistasContratos,
    children: [
      {
        name: 'contratitasContratos',
        path: '/',
        meta: {
          title: 'Contratos',
        },
        component: DefaultContratistasContratos,

        children: [],
      },
      {
        path: ':idContrato',
        component: MainContrato,
        children: [
          {
            name: 'contratistaContratoGenerales',
            path: 'genrales',
            meta: {
              title: 'Generales',
            },
            props: {
              soloLectura: true,
            },
            component: MainContratoGenerales,
          },
          {
            name: 'contratistaContratoReportesFisicos',
            path: 'reportes',
            meta: {
              title: 'Reportes',
              auth,
              scopes,
            },
            props: {
              soloLectura: false,
            },
            component: MainContratoReporteFisico,
          },
          {
            name: 'contratistaContratoFrentes',
            path: 'frentes',
            meta: {
              title: 'Frentes',
            },
            props: {
              soloLectura: false,
            },
            component: MainContratosFrentes,
          },
          {
            name: 'contratistaContratoDiarioActividades',
            path: 'diario-actividades',
            meta: {
              title: 'Diario actividades',
            },
            props: {
              soloLectura: false,
            },
            component: MainContratistasDiarioActividades,
          },
          {
            name: 'contratistaContratoArchivos',
            path: 'contrato-archivos',
            meta: {
              title: 'Archivos contrato',
            },
            props: {
              soloLectura: false,
            },
            component: MainContratosArchivosContratista,
          },
          {
            name: 'contratistrasContratoMinutas',
            path: 'minutas',
            meta: {
              title: 'Minutas',
            },
            component: MainContratistasMinutas,
          },
          {
            name: 'contratistaContratoEstimacionesAnticipos',
            path: 'anticipos',
            meta: {
              title: 'Anticipos',
            },
            props: {
              soloLectura: true,
            },
            component: MainAnticipos,
          },
          {
            name: 'contratistasContratoConveniosModificatorios',
            path: 'convenios',
            meta: {
              title: 'Convenios modificatorios',
            },
            props: {
              soloLectura: true,
            },
            component: MainConvenios,
          },
          {
            name: 'contratistasContratoCatalogo',
            path: 'catalogo',
            meta: {
              title: 'Catálogo',
            },
            props: {
              soloLectura: true,
            },
            component: MainCatalogo,
          },
          {
            name: 'contratistaContratoPrograma',
            path: 'programa',
            meta: {
              title: 'Programa',
            },
            props: {
              soloLectura: true,
            },
            component: MainPrograma,
          },
          {
            name: 'contratistasContratoExpediente',
            path: 'expediente',
            meta: {
              title: 'Expediente',
            },
            component: MainExpediente,
          },
          {
            name: 'contratistaContratoDirectorio',
            path: 'directorio',
            meta: {
              title: 'Directorio',
            },
            component: MainContratosDirectorio,
          },
          {
            name: 'contratistaContratoAgenda',
            path: 'agenda',
            meta: {
              title: 'Agenda',
            },
            component: MainContratosAgenda,
          },
        ],
      },
    ],
  },
];

export default contratos;
